import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import TopBar from './TopBar';
import Footer from './Footer';

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const hideMenu = pathname === "/app/events/create" || sessionStorage.getItem('from_auto_login') === '1';

  return (
    <>
    <TopBar />
    <div className='content-wrapper' style={hideMenu ? { paddingTop: 70 } : {}}>
      <Outlet />
    </div>
    <Footer />
    </>
  )
}
